export const GET_ANNOUNCEMENTS_START='GET_ANNOUNCEMENTS_START';
export const GET_ANNOUNCEMENTS_SUCCESS='GET_ANNOUNCEMENTS_SUCCESS';
export const GET_ANNOUNCEMENTS_FAIL='GET_ANNOUNCEMENTS_FAIL';

export const UPDATE_ANNOUNCEMENT_START='UPDATE_ANNOUNCEMENT_START';
export const UPDATE_ANNOUNCEMENT_SUCCESS='UPDATE_ANNOUNCEMENT_SUCCESS';
export const UPDATE_ANNOUNCEMENT_FAIL='UPDATE_ANNOUNCEMENT_FAIL';

export const TOGGLE_ANNOUNCEMENT_UPDATE='TOGGLE_ANNOUNCEMENT_UPDATE';